module.exports = __webpack_public_path__ + "359db059.png";